import set from 'lodash.set';

import { i18n } from '@services';

export const tt = (message, options) => i18n.t(message, options);
tt.options = (translateOptions) => ({ translateOptions });
set(tt, 'ns.backend', { ns: 'backend' });
set(tt, 'ns.default', { ns: 'shared' });
